import React from 'react';
import PageHeader from 'components/PageHeader/PageHeader';
import { Text } from 'components/core';

type Props = {
  headerText: string;
  backLink: string;
  authorEmail: string;
};

const AuthorPageHeader = ({ headerText, backLink, authorEmail }: Props) => {
  const Address = () => <Text variant="weak">{authorEmail}</Text>;

  return (
    <PageHeader
      headerText={headerText}
      backLink={backLink}
      rightContent={Address}
    />
  );
};

export default AuthorPageHeader;
